"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnStateCompleteBase = void 0;
const Entities_1 = require("../../Entities");
class OnStateCompleteBase extends Entities_1.RequestHandler {
    constructor(hostHandler) {
        super();
        this.requestType = 'ON_STATE_COMPLETED';
        this.action = () => {
            throw new Entities_1.ActionNotImplemented(this.requestType);
        };
        this.handleRequest = (version) => {
            if (version === 1) {
                this.action();
            }
            else {
                throw new Entities_1.UnsupportedRequestVerion(this.requestType, version);
            }
        };
        hostHandler.registerRequestHandler(this);
    }
}
exports.OnStateCompleteBase = OnStateCompleteBase;
